import React from 'react';
import RawHtml from '@components/RawHtml';
import Link from 'next/link';
import Image from 'next/image';
import { addBaseUrl, removeBaseUrl } from '@/utils/url';
import { WagtailImage } from '@/types';

interface SocialMediaData {
  image: WagtailImage | null;
  link: string;
  title: string;
  id: number;
  svg: string | null;
  ariatext: string;
}

interface FooterMenuData {
  id: number;
  title: string;
  link_intern_full_url: string | null;
  link_url: string | null;
}

interface FooterData {
  id: number;
  text: string | null;
  social_media: SocialMediaData[];
  footer_menu: FooterMenuData[];
}

interface Props {
  data: FooterData | null;
}

function Footer(props: Props) {
  const { data } = props;

  const current = new Date();
  const date = `${current.getFullYear()}`;

  return (
    <footer className='footer'>
      <div className='container'>
        {data?.text ? <RawHtml className='footer__text' html={data.text} /> : null}

        {data?.social_media?.length ? (
          <div className='footer__social'>
            {data?.social_media.map(item => (
              <Link
                key={item.id}
                href={item.link}
                passHref
                className='footer__socialitem'
                aria-label={item.ariatext}
                target='_blank'
                rel='noreferrer'
              >
                {item.image && !item.svg ? (
                  <Image
                    src={addBaseUrl(item.image.meta.download_url)}
                    alt={item.image.title}
                    layout='fixed'
                    className='socialicon'
                    objectFit='contain'
                    width={40}
                    height={40}
                  />
                ) : null}
                {item.svg ? <RawHtml className='socialicon' html={item.svg} /> : null}
              </Link>
            ))}
          </div>
        ) : null}
        <div className='footer__menu'>
          {data?.footer_menu.length ? (
            <ul className='footer__menu-list'>
              {data.footer_menu.map(entry => (
                <li key={entry.id} className='footer__menu-list-item'>
                  <Link
                    href={
                      entry.link_intern_full_url
                        ? removeBaseUrl(entry.link_intern_full_url)
                        : (entry.link_url ?? '/')
                    }
                    passHref
                  >
                    {entry.title}
                  </Link>
                </li>
              ))}
            </ul>
          ) : null}
          <p className='footer__copy'>© {date} Stadtwerke Witten</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
